// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../fetch.pb.js";
export const HydraShell = {
    InitialOAuth2LoginRequest(fn, req) {
        return fn(`/hydra-shell/login/oauth2`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    AcceptOAuth2LoginRequest(fn, req) {
        return fn(`/hydra-shell/login/oauth2/accept`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    InitialOAuth2ConsentRequest(fn, req) {
        return fn(`/hydra-shell/consent/oauth2`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    AcceptOAuth2ConsentRequest(fn, req) {
        return fn(`/hydra-shell/consent/oauth2/accept`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    InitialOAuth2LogoutRequest(fn, req) {
        return fn(`/hydra-shell/logout/oauth2`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    AcceptOAuth2LogoutRequest(fn, req) {
        return fn(`/hydra-shell/logout/oauth2/accept`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
